// extracted by mini-css-extract-plugin
export default {"back-button":"AJnI8u","backButton":"AJnI8u","back-button-with-sale":"REn4ib","backButtonWithSale":"REn4ib","new-ui-root":"uzHAnA","newUiRoot":"uzHAnA"};